<template>
	<div class="small-12 articleFeatureImage flex" v-if="article">
        <picture class="small-12 large-9 float-left">
            <img :src="article.links.feature_image" alt="Feature Image">
        </picture>
    </div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ArticleFeatureImage',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			article: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>